// src/services/AuthService.js
import axios from 'axios';

// Ensure the API URL is correct and include the trailing slash
const API_URL = 'https://erp.ycsols.com/api/'; // Include the trailing slash

export const AuthService = {
  async login(credentials) {
    try {
      // Check if the credentials are being sent correctly
      const response = await axios.post(`${API_URL}ycslogin`, credentials);
      return response.data; // Return the actual data from the response
    } catch (error) {
      console.error("Login failed:", error.response ? error.response.data : error.message);
      throw error; // Rethrow the error for handling in the component
    }
  },

  async forgotPassword(credentials) {
    try {
      const response = await axios.post(`${API_URL}ycsforgotpassword`, credentials);
      return response.data;
    } catch (error) {
      console.error("Forgot password failed:", error.response ? error.response.data : error.message);
      throw error;
    }
  },
};

